import React, {useState, useEffect, Fragment} from 'react';
import {BrowserRouter as Router, Route, Switch, Link, Redirect} from "react-router-dom";
import {Row, Col, Label, Input, Button, Container} from 'reactstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFilePdf} from '@fortawesome/free-solid-svg-icons';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import PageURL from "../PageURL.js";

import CustomTable from '../Utils/CustomTable.jsx';
import {postApiRequest, convertIsoToYmdHis} from "../Utils/Utils.js";

const PageDownloadLogs = function() {
  const [supplier, setSupplier] = useState("");
  const [downloadLogCountPath, setDownloadLogCountPath] = useState("download_log/count");
  const tableColumns = [
      //Text, Class
    ["Company", ""],
    ["Customer Code", ""],
    ["Sales Order", ""],
    ["SO Line", ""],
    ["Delivery", ""],
    ["Del Line", ""],
    ["Del Doc Date", ""],
    ["Customer Reference", ""],
    ["Line Reference", ""],
    ["Item Code", ""],
    ["Item Description", ""],
    ["Heat Number", ""],
    ["Download info", ""],
  ];
  const columnKeys = [
      //Object key, Class
    ["companycode", ""],
    ["bpcode", ""],
    ["salesordernumber", ""],
    ["salesorderlinenumber", ""],
    ["deliverynumber", ""],
    ["deliverylinenumber", ""],
    ["deliverydate", ""],
    ["customerreference", ""],
    ["salesorderlinereference", ""],
    ["itemcode", ""],
    ["itemdescription", ""],
    ["heatnumber", ""],
    ["__actions", ""]
  ];
  const [searchQuery, setSearchQuery] = useState("download_logs");
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [resetTableCounter, setResetTableCounter] = useState(0);
  const tableActionPdfIcon = <FontAwesomeIcon style={{cursor: "pointer"}} size="lg" icon={faFilePdf} color="red" title="Open PDF"></FontAwesomeIcon>;
  const tableActionUserIcon = <FontAwesomeIcon style={{cursor: "pointer"}} size="lg" icon={faUser} color="blue" title="Open user"></FontAwesomeIcon>;

  const tableActionPdf = async function(dataItem) {
    let obj = {
      "id" : dataItem.deliverylineid
    };
    const response = await postApiRequest(JSON.stringify(obj), "certificate/download");
    if (response.status === 200) {
      const responseData = await response.json();
      const bString = window.atob(responseData.data);
      const bLength = bString.length;
      const bytes = new Uint8Array(bLength);
      for (let i = 0; i < bLength; i++) {
        bytes[i] = bString.charCodeAt(i);
      }
      const newBlob = new Blob([bytes], {type: "application/pdf"});
      const fileURL = URL.createObjectURL(newBlob);
        //NOTE(muamer): The following approach can be used to enforce our file name but it will be downloaded straight up
      //const link = document.createElement('a');
      //link.href = fileURL;
      //link.setAttribute('download', dataItem.deliverynumber + "_" + dataItem.deliverylinenumber);
      //document.body.appendChild(link);
      //link.click();
      window.open(fileURL);
    }
  };

  const dataReceivedCallback = function(data) {
    for (let i = 0, n = data.length; i < n; i++) {
      data[i].__id = i;
      data[i].__actions = [
        <>
          <Row>
            <span>{convertIsoToYmdHis(data[i].downloaddate, "-", ":")}</span>
          </Row>
          <Row>
            <Col xs="6">
              <span onClick={() => tableActionPdf(data[i])}>{tableActionPdfIcon}</span>
            </Col>
            <Col xs="6">
              <a target="_blank" rel="noreferrer" href={window.location.origin + PageURL.userAccounts + "?username="+data[i].useremail}>{tableActionUserIcon}</a>
            </Col>
          </Row>
        </>
      ];
    }
    return data;
  };

  useEffect(() => {
    document.title = "VLBC - Download logs";
  }, []);

  return (
  <Fragment>
    <div className="title-box">
      <h1 className="page-title">Download logs</h1>
    </div>
    <Container fluid className="element-box">
      <CustomTable resetCounter={resetTableCounter} maxItemsLink={downloadLogCountPath} refreshCounter={refreshCounter} visible="false" columns={tableColumns} columnKeys={columnKeys}
        apiPath={searchQuery} dataReceivedCallback={dataReceivedCallback} />
    </Container>
  </Fragment>
  );
};

export default PageDownloadLogs;